var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slug.split('-').slice(-1).pop() > 1)?_c('small',[_vm._v("("+_vm._s(_vm.slug.split('-').slice(-1).pop())+")")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }